// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import {FixedSpace} from '../core/Spacing';
import {HeadingLargeText, BodyText, LabelMediumText} from '../core/Type';
// Controls
import Button from '../controls/Button';
import SelectBox from '../controls/SelectBox';
// Layouts
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';
// Assets
import Glyph from '../core/Glyph';


export default class Modals extends React.Component {
    render() {
        const closeIcon = <Glyph
            styles={[styles.closeIcon]}
            asset="assets/24x24-close.svg"
            size={Glyph.Size.Medium}
            fillColor={CoreMetrics.Color.Neutral.White}
        />;

        const title = <HeadingLargeText styles={[styles.title]}>
            Join millions across the globe by signing up
        </HeadingLargeText>;
        const description = <BodyText styles={[styles.description]}>
            Use Khan Academy to prepare for the SAT, practice for an Algebra test, or
            try something brand new.
        </BodyText>;
        const label = <LabelMediumText styles={[styles.label]}>
            What will you be using Khan Academy for?
        </LabelMediumText>;
        const selectBox = <SelectBox
            placeholder="Select one" options={["One", "Two", "Three"]}
            styles={[styles.selectBox]}
        />;
        const googleButton = <Button
            title="Sign up with Google"
            styles={[styles.googleButton]}
        />;
        const facebookButton = <Button
            title="Sign up with Facebook"
            styles={[styles.facebookButton]}
        />;

        const verticalSpaceBetween = <FixedSpace
            variant={FixedSpace.Variant.Vertical}
            size={FixedSpace.Size.XXLarge}
        />;

        const emptyColumnDesktop = <CssGridSpace size={0} sizeDesktop={1} />;

        return (
            <div className={css(styles.homepage)}>
                {verticalSpaceBetween}

                <CssGrid>
                    <CssGridRow>
                        {emptyColumnDesktop}
                        <CssGridColumn sizeDesktop={10}>
                            <div
                                className={css(
                                    styles.modal,
                                    styles.modalSpacerBlocks
                                )}
                            >
                                {closeIcon}
                                <div
                                    className={css(
                                        styles.descriptionScreen,
                                        styles.screenSpacerBlocks,
                                    )}
                                >
                                    {title}
                                    {description}
                                </div>
                                <div
                                    className={css(
                                        styles.actionScreen,
                                        styles.screenSpacerBlocks,
                                    )}
                                >
                                    {label}
                                    {selectBox}
                                    {googleButton}
                                    {facebookButton}
                                </div>
                            </div>
                        </CssGridColumn>
                        {emptyColumnDesktop}
                    </CssGridRow>
                </CssGrid>

                {verticalSpaceBetween}

                <div
                    className={css(
                        styles.modal,
                        styles.splitScreenModal,
                        styles.modalInternalGrid,
                    )}
                >
                    {closeIcon}
                    <div
                        className={css(
                            styles.descriptionScreen,
                            styles.descriptionScreenInternalGrid,
                        )}
                    >
                        {title}
                        {description}
                    </div>
                    <div
                        className={css(
                            styles.actionScreen,
                            styles.actionScreenInternalGrid,
                        )}
                    >
                        {label}
                        {selectBox}
                        {googleButton}
                        {facebookButton}
                    </div>
                </div>

                {verticalSpaceBetween}

                <div
                    className={css(
                        styles.modal,
                        styles.splitScreenModal,
                        styles.modalInternalGrid,
                        styles.modalInternalGridWide,
                    )}
                >
                    {closeIcon}
                    <div
                        className={css(
                            styles.descriptionScreen,
                            styles.descriptionScreenInternalGrid,
                        )}
                    >
                        {title}
                        {description}
                    </div>
                    <div
                        className={css(
                            styles.actionScreen,
                            styles.actionScreenInternalGrid,
                        )}
                    >
                        {label}
                        {selectBox}
                        {googleButton}
                        {facebookButton}
                    </div>
                </div>

                {verticalSpaceBetween}
            </div>
        );
    }
}


const styles = createExpandableMediaQueryStylesheet({
    homepage: {
        height: "100vh",
        backgroundColor: CoreMetrics.Color.LoggedOut.BGBlue,
        background: `linear-gradient(
            to bottom,
            ${CoreMetrics.Color.LoggedOut.BGBlue},
            ${CoreMetrics.Color.LoggedOut.BGGreen}
        )`,
        backgroundAttachment: "fixed",
        paddingLeft: CoreMetrics.Grid.HorizontalMargin,
        paddingRight: CoreMetrics.Grid.HorizontalMargin,
    },
    modal: {
        borderRadius: CoreMetrics.CornerRadius,
        position: "relative",
    },
    splitScreenModal: {
        background: `linear-gradient(
            to right,
            ${CoreMetrics.Color.LoggedOut.DarkBlue} 0%,
            ${CoreMetrics.Color.LoggedOut.DarkBlue} 50%,
            white 50%,
            white 100%
        )`,

        [CoreMetrics.MediaQuery().Phone]: {
            background: "none",
        },
    },
    descriptionScreen: {
        backgroundColor: CoreMetrics.Color.LoggedOut.DarkBlue,
        paddingTop: CoreMetrics.ElementSpacing.XXXLarge(),
        paddingBottom: CoreMetrics.ElementSpacing.XXXLarge(),
        borderRadius:
            `${CoreMetrics.CornerRadius}px 0 0 ${CoreMetrics.CornerRadius}px`,

        [CoreMetrics.MediaQuery().Phone]: {
            borderRadius: `${CoreMetrics.CornerRadius}px`
                + ` ${CoreMetrics.CornerRadius}px 0 0`,
        },
    },
    actionScreen: {
        paddingTop: CoreMetrics.ElementSpacing.XXXLarge(),
        paddingBottom: CoreMetrics.ElementSpacing.XXXLarge(),
        backgroundColor: CoreMetrics.Color.Neutral.White,
        borderRadius:
            `0 ${CoreMetrics.CornerRadius}px ${CoreMetrics.CornerRadius}px 0`,

        [CoreMetrics.MediaQuery().Phone]: {
            borderRadius: `0 0 ${CoreMetrics.CornerRadius}px`
                + ` ${CoreMetrics.CornerRadius}px`,
        },
    },
    closeIcon: {
        position: "absolute",
        top: CoreMetrics.ElementSpacing.Large(),
        left: CoreMetrics.ElementSpacing.Large(),
    },
    title: {
        fontWeight: "bold",
        color: CoreMetrics.Color.Neutral.White,
        marginBottom: CoreMetrics.ElementSpacing.Small(),
    },
    description: {
        color: CoreMetrics.Color.Neutral.White,
    },
    label: {
        fontWeight: "bold",
        marginBottom: CoreMetrics.ElementSpacing.Small(),
    },
    selectBox: {
        marginBottom: CoreMetrics.ElementSpacing.XLarge(),
    },
    googleButton: {
        width: "100%",
        backgroundColor: CoreMetrics.Color.ExternalBrands.Google,
        marginBottom: CoreMetrics.ElementSpacing.XSmall(),
    },
    facebookButton: {
        width: "100%",
        backgroundColor: CoreMetrics.Color.ExternalBrands.Facebook,
    },
    modalSpacerBlocks: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",

        [CoreMetrics.MediaQuery().Phone]: {
            gridTemplateColumns: "1fr",
        },
    },
    screenSpacerBlocks: {
        padding: CoreMetrics.ElementSpacing.XXXLarge(),
    },
    modalInternalGrid: {
        // TODO(diedra): If this variant succeeds, figure out what to do with
        // this number.
        maxWidth: 700,
        margin: "0 auto",
        paddingLeft: CoreMetrics.ElementSpacing.XXXLarge(),
        paddingRight: CoreMetrics.ElementSpacing.XXXLarge(),
        display: "grid",
        gridTemplateColumns: "repeat(9, 1fr)",
        gridTemplateAreas:
            '"description description description description'
            + ' .'
            + ' action action action action"',
        gridColumnGap: CoreMetrics.Grid.HorizontalGutter,

        [CoreMetrics.MediaQuery().Phone]: {
            padding: 0,
            gridTemplateColumns: "repeat(4, 1fr)",
            gridTemplateAreas:
                '"description description description description"'
                + '"action action action action"',
        },
    },
    descriptionScreenInternalGrid: {
        gridArea: "description",

        [CoreMetrics.MediaQuery().Phone]: {
            padding: CoreMetrics.Grid.HorizontalGutter,
        },
    },
    actionScreenInternalGrid: {
        gridArea: "action",

        [CoreMetrics.MediaQuery().Phone]: {
            padding: CoreMetrics.Grid.HorizontalGutter,
        },
    },
    modalInternalGridWide: {
        // TODO(diedra): If this variant succeeds, figure out what to do with
        // this number.
        maxWidth: 860,
        paddingTop: 6,
        gridTemplateColumns: "repeat(11, 1fr)",
        gridTemplateAreas:
            '"description description description description description'
            + ' .'
            + ' action action action action action"',
    },
});



// WEBPACK FOOTER //
// ./src/demo/Modals.jsx